import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { FileDown, ImageDown, CreditCard } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

const save = (blob, name) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
};

export const PrintCard = () => {
  const { data: sticker } = useQuery({ queryKey: ["sticker"], queryFn: api.sticker });
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => {
    if (!sticker) return;
    let url;
    api.stickerCard("png").then((b) => setPreview((url = URL.createObjectURL(b))), () => setPreview(null));
    return () => url && URL.revokeObjectURL(url);
  }, [sticker]);

  const download = async (fmt) => {
    setBusy(fmt);
    try { save(await api.stickerCard(fmt), `bucketlist-card.${fmt}`); }
    catch { toast.error("Couldn't make the card — try again"); }
    setBusy("");
  };

  return (
    <section className="rounded-2xl border border-white/10 bg-white/5 p-4 space-y-3" data-testid="print-card">
      <div className="flex items-center gap-2"><CreditCard size={18} className="text-emerald-300" /><h3 className="font-semibold">Printable business card</h3></div>
      <p className="text-sm text-slate-300">Your name and a QR code. People scan it with their camera and can send you a friend request — no NFC needed.</p>
      <div className="overflow-hidden rounded-xl aspect-[91/61] bg-white/5" data-testid="print-card-preview">
        {preview ? <img src={preview} alt="Your business card" className="w-full h-full object-cover" /> : <div className="w-full h-full animate-pulse" />}
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Button onClick={() => download("pdf")} disabled={!sticker || !!busy} className="bg-emerald-400 text-[#06121c] hover:bg-emerald-300" data-testid="print-card-pdf"><FileDown size={14} /> {busy === "pdf" ? "Making…" : "Download PDF"}</Button>
        <Button variant="secondary" onClick={() => download("png")} disabled={!sticker || !!busy} data-testid="print-card-png"><ImageDown size={14} /> {busy === "png" ? "Making…" : "Download image"}</Button>
      </div>
      <p className="text-[11px] text-slate-500">Print-shop ready: 85 × 55 mm with 3 mm bleed, 300 dpi. It uses your sticker link, so Reset above also switches off printed cards.</p>
    </section>
  );
};
